import { DivisionDependencyMatrix as ProcessAreasDivisions } from '../pages/exposure/process-areas-dependencies/types';
import { DivisionDependencyMatrix as ProcessesDivisions } from '../pages/exposure/processes-and-equipment/processesTypes';

export type DivisionType = ProcessAreasDivisions | ProcessesDivisions;

export const cleanFinancials = (division: DivisionType[]): DivisionType[] => {
  return division.map((divisionItem) => {
    // Filter out ProductGroupFinancials with supportedRevenue of 0
    const filteredChildren = divisionItem?.children?.filter(
      (group) => group.supportedRevenue !== 0,
    );

    // Filter out ProductFinancials children with supportedRevenue of 0
    const cleanedChildren = filteredChildren?.map((group) => {
      return {
        ...group,
        children: group?.children?.filter(
          (child) => child.supportedRevenue !== 0,
        ),
      };
    });

    const cleanedIntermediates = divisionItem?.intermediates?.filter(
      (group) => group.supportedRevenue !== 0,
    );

    return {
      ...divisionItem,
      children: [...cleanedChildren, ...cleanedIntermediates],
    };
  });
};
